export const PROJECT_LINK_CONFIG = {
    name        : 'Link',
    icon        : 'ii5-task-list', //'i5-sticky-note',
    // iconLight   : 'ii5-task-list', //'i5-document-light',
    // image       : 'notes-docs',
    iconSvg     : 'isvg-link',
    url         : 'link',
    // stringId    : 'page',
    description : 'Custom link',
    // menuName    : 'Page',
    inheritance : false,
    projectIcon : 'link',
}
